import React, { useState, useEffect, useCallback } from 'react';
import KickImage from 'Reuseables/KickImage';
import FlashSaleBanner from "../../images/flashsalemobile1024.png"
import FlashSaleDesktop from "../../images/flash-sale-banner.png"
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";
import moment from "moment"
import { connect } from "react-redux"
import {
  getCollectionProductBrands
} from "../../actions/kafairAction";
import classNames from "classnames";
import { getFlashSaleCollectionList, getFlashSaleSetting } from "../../actions/productAction"
import { getCollectionList } from "../../actions/kafairAction"
import { getCloudImageUrl, emptyImage } from "../../utils";
import { TextRupiah } from "../Text"
import Countdown from "react-countdown"
import { withRouter, history, Link } from "react-router-dom"
import MagnifyingGlass from "../../images/magnifying-glass.png"
import { Container } from "reactstrap";
import MissingShoes from "../../images/dashboard-empty-state.png"
import ArrowDown from "../../images/arrowsDown.png"
import { debounce, delay } from "lodash"
import SneakerLoadingSpinner from "../Sneakers/SneakerLoadingSpinner"

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  // const newHours = days * 24 + hours;
  return (
    <span style={{ color: "#fec350", fontFamily: "Nunito Bold" }}>
      {days < 10 ? `0${days}` : days}<span style={{ fontSize: "10px", fontFamily: "Nunito Regular", color: "#242424" }}> days</span> {hours < 10 ? `0${hours}` : hours}<span style={{ fontSize: "10px", fontFamily: "Nunito Regular", color: "#242424" }}> hours</span> {minutes < 10 ? `0${minutes}` : minutes}<span style={{ fontSize: "10px", fontFamily: "Nunito Regular", color: "#242424" }}> minutes</span> {seconds < 10 ? `0${seconds}` : seconds}<span style={{ fontSize: "10px", fontFamily: "Nunito Regular", color: "#242424" }}> seconds</span>
    </span>
  );
};

const styleDrawer = {
  borderRadius: "3px",
  marginTop: "8px",
  zIndex: 500,
  backgroundColor: "#fff",
  position: "absolute",
  width: "140px",
  border: "1px solid #ddd",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.16)"
}

const styleTextBold = {
  fontSize: "12px",
  fontFamily: "Nunito Bold",
  margin: "8px"
}

const styleTextNormal = {
  fontSize: "12px",
  fontFamily: "Nunito Regular",
  margin: "8px"
}

const styleOption = {
  height: "40%",
  display: "flex",
  alignItems: "center",
  cursor: "pointer"
}

const sort = [
  {
    id: 1,
    name: "Latest",
    value: "latest"
  },
  {
    id: 2,
    name: "Lowest Price",
    value: "price_asc"
  },
  {
    id: 3,
    name: "Highest Price",
    value: "price_desc"
  }
]

const filterPrice = [
  {
    id: 1,
    name: "under IDR 1.000.000",
    start_price: 0,
    end_price: 999999
  },
  {
    id: 2,
    name: "IDR 1,000,001 - IDR 2,000,000",
    start_price: 1000000,
    end_price: 1999999
  },
  {
    id: 3,
    name: "above IDR 2,000,000",
    start_price: 2000000,
    end_price: 1000000000000000
  }
]

function FlashSalePage({ dataCategory, getCollectionProductBrands, history, getFlashSaleCollectionList, getFlashSaleSetting, location, match, getCollectionList, underRetailProducts, merchandiseProducts }) {

  const [data, setData] = useState([])

  /* temporaryData dipakai sebagai params useEffect untuk fungsi load more agar tidak perlu merubah redux */
  const [temporaryData, setTemporaryData] = useState([]);

  const [selectedSort, setSelectedSort] = useState("Lowest Price")
  const [selectedFilter, setSelectedFilter] = useState("")
  const [searchInput, setSearchInput] = useState("")
  const [openSortDrawer, setOpenSortDrawer] = useState(false)
  const [pageDetail, setPageDetail] = useState(null)
  const [page, setPage] = useState(1)
  const [previousPage, setPreviousPage] = useState([])
  const [noData, setNoData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showLoadMore, setShowLoadMore] = useState(true)
  const [windowHeight, setWindowHeight] = useState(0)
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false)
  const [dataProduct, setDataProduct] = useState({
    isFetching: true,
    hasMoreData: true
  })
  const [hoveredWidget, setHoveredWidget] = useState("")

  const searchHandler = useCallback(debounce((payload, string, product) => {
    submitSearch(payload, string, product)
  }, 1500), []);

  const loadMoreHandler = useCallback(
    debounce((payload, string) => {
      submitSearch(payload, string);
    }, 100),
    []
  );

  useEffect(() => {
    setPage(1)
    const sortParams = sort.find(item => item.name === selectedSort).value

    const { category, slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "official-merchandise" : slug.replace("-", "_")

    let payload = {
      sort_by: sortParams,
      collection: "flash-sale",
      keyword: searchInput,
      pre_verified: true,
      page,
      availables: true
    }

    setLoading(true)

    if (slug) {
      if (slug === "flash-sale") {
        getFlashSaleSetting()
          .then(({ value }) => {
            const slug = value.data.data[0].value;
            setNoData(false)
            getFlashSaleCollectionList(dataCategory, slug)
              .then(({ value }) => {
                setPageDetail(value.data)
              })
              .then(_ => getCollectionProductBrands(payload, "flash_sale"))
              .then(({ value }) => {
                setLoading(false)
                if (!value.data.next_page_url) {
                  setShowLoadMore(false)
                } else {
                  setShowLoadMore(true)
                }
                setNoData(false)
                setData(value.data.data)
              })
              .catch(e => {
                setPage(1)
                setNoData(true)
                setLoading(false)
                setShowLoadMore(false);
              })
          })
      } else {
        payload = {
          collection: slug,
          collection_type: "product_variants",
          availables: true,
          sort_by: sortParams,
          keyword: searchInput,
          page: 1
        }

        if (slug === "under-retail-bca-launch") {
          payload = {
            ...payload,
            pre_verified: true
          }
        }

        fetchData(payload)
      }
    }
  }, [location])

  useEffect(() => {
    setData(page === 1 ? temporaryData : [...data, ...temporaryData]);
  }, [temporaryData]);

  useEffect(() => {
    const { category, slug } = match.params
    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "official-merchandise" : slug.replace("-", "_")
    const tempDataProduct = name === "under_retail" ? underRetailProducts : name === "official-merchandise" ? merchandiseProducts : []
    setDataProduct(tempDataProduct)
  }, [underRetailProducts, merchandiseProducts])

  useEffect(() => {
    const { hasMoreData } = dataProduct || {};
    hasMoreData
      ? document.addEventListener("scroll", trackScrolling)
      : document.removeEventListener("scroll", trackScrolling);
  }, [dataProduct])

  function fetchData(payload) {

    const { slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")

    getCollectionProductBrands(payload, name)
      .then(({ value }) => {
        setLoading(false)
        if (!value.data.next_page_url) {
          setShowLoadMore(false)
        } else {
          setShowLoadMore(true)
        }
        setNoData(false)
        setTemporaryData(value.data.data)
      })
      .then(_ => getCollectionList("bca", slug, {}, name))
      .then(({ value }) => {
        setPageDetail(value.data)
      })
      .catch(e => {
        setPage(1)
        setNoData(true)
        setLoading(false)
        setShowLoadMore(false);
      })
  }

  function submitSearch(payload, string, products) {
    const { slug } = match.params
    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")
    if (slug) {
      if (slug === "flash-sale") {
        setLoading(true)
        getCollectionProductBrands(payload, "flash_sale")
          .then(({ value }) => {
            setLoading(false)
            if (!value.data.next_page_url) {
              setShowLoadMore(false)
            } else {
              setShowLoadMore(true)
            }
            setNoData(false)
            setData([...products, ...value.data.data])
          })
          .catch(e => {
            setPage(1)
            setNoData(true)
            setLoading(false)
            setShowLoadMore(false);
          })
      } else {
        setLoading(true)
        getCollectionProductBrands(payload, name)
          .then(({ value }) => {
            setLoading(false)
            if (!value.data.next_page_url) {
              setShowLoadMore(false)
            } else {
              setShowLoadMore(true)
            }
            setNoData(false)
            setTemporaryData(value.data.data)
          })
          .catch(e => {
            setPage(1)
            setNoData(true)
            setLoading(false)
            setShowLoadMore(false);
          })
      }
    }
  }

  function handleSearchInput(e) {
    setSearchInput(e.target.value)

    setPage(1)

    setShowLoadMore(true)

    const sortParams = selectedSort ? sort.find(item => item.name === selectedSort).value : ""

    const startPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).start_price : ""

    const endPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).end_price : ""

    const { slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")

    let payload = {}

    if (slug === "flash-sale") {
      payload = {
        sort_by: sortParams,
        collection: "flash-sale",
        keyword: e.target.value,
        pre_verified: true,
        page: 1,
        availables: true
      }
    } else if (slug === "under-retail-bca-launch") {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: e.target.value,
        page: 1,
        availables: true,
        pre_verified: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    } else {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: e.target.value,
        page: 1,
        start_price: startPriceFilter,
        end_price: endPriceFilter,
        availables: true
      }
    }


    searchHandler(payload, name, [])
  }

  function handleOpenSortDrawer() {
    setOpenSortDrawer(!openSortDrawer)
    setOpenFilterDrawer(false)
  }

  function handleOpenFilterDrawer() {
    setOpenFilterDrawer(!openFilterDrawer)
    setOpenSortDrawer(false)
  }

  function handleSortChange(value) {
    setSelectedSort(value)

    setPage(1)

    setShowLoadMore(true)

    const sortParams = sort.find(item => item.name === value).value

    const startPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).start_price : ""

    const endPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).end_price : ""

    const { slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")
    let payload = {}

    if (slug === "flash-sale") {
      payload = {
        sort_by: sortParams,
        collection: "flash-sale",
        keyword: searchInput,
        pre_verified: true,
        page: 1,
        availables: true
      }
    } else if (slug === "under-retail-bca-launch") {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: 1,
        availables: true,
        pre_verified: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    } else {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: 1,
        availables: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    }

    submitSearch(payload, name, [])
  }

  function handleFilterChange(filterName, start, end) {
    setSelectedFilter(filterName)

    setPage(1)

    setShowLoadMore(true)

    const sortParams = sort.find(item => item.name === selectedSort).value

    const startPriceFilter = filterPrice.find(item => item.name === filterName).start_price

    const endPriceFilter = filterPrice.find(item => item.name === filterName).end_price

    const { slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")
    let payload = {}

    if (slug === "flash-sale") {
      payload = {
        sort_by: sortParams,
        collection: "flash-sale",
        keyword: searchInput,
        pre_verified: true,
        page: 1,
        availables: true
      }
    } else if (slug === "under-retail-bca-launch") {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: 1,
        availables: true,
        pre_verified: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    } else {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: 1,
        availables: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    }

    submitSearch(payload, name, [])
  }

  function goToProductPage(id, productSlug, categoryData) {

    const { slug } = match.params

    const categoryUrl =
      categoryData === "apparels" || categoryData === "Apparels"
        ? "apparel"
        : categoryData === "lifestyles"
          ? "electronics-collectibles"
          : categoryData === "handbags"
            ? "luxury"
            : categoryData;

    if (slug === "flash-sale") {
      history.push(`/${categoryUrl}/${id}/${productSlug}?pre_verified=true`)
    } else if (slug === "under-retail-bca-launch") {
      window.location.href = `/${categoryUrl}/${id}/${productSlug}?pre_verified=true?product=under-retail`
    } else {
      window.location.href = `/${categoryUrl}/${id}/${productSlug}`
    }
  }

  function handlePageShow(params) {
    let num = JSON.parse(JSON.stringify(page)) + 1

    setPage(num)

    const sortParams = selectedSort ? sort.find(item => item.name === selectedSort).value : ""

    const startPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).start_price : ""

    const endPriceFilter = selectedFilter ? filterPrice.find(item => item.name === selectedFilter).end_price : ''

    const { slug } = match.params

    const name = slug === 'under-retail-bca-launch' ? "under_retail" : slug === "official-merchandise" ? "merchandise" : slug.replace("-", "_")

    let payload = {}

    if (slug === "flash-sale") {
      payload = {
        sort_by: sortParams,
        collection: "flash-sale",
        keyword: searchInput,
        pre_verified: true,
        page: num,
        availables: true
      }
    } else if (slug === "under-retail-bca-launch") {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: num,
        pre_verified: true,
        availables: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    } else {
      payload = {
        sort_by: sortParams,
        collection: slug,
        keyword: searchInput,
        page: num,
        availables: true,
        start_price: startPriceFilter,
        end_price: endPriceFilter
      }
    }

    loadMoreHandler(payload, name, data)
  }

  const isBottom = (el) => {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  };

  const trackScrolling = async () => {
    const { isFetching, hasMoreData } = dataProduct;
    if (isFetching || !hasMoreData) return;
    const wrappedElement = document.getElementById("load-more-button");
    if (wrappedElement && isBottom(wrappedElement)) {
      await document.removeEventListener("scroll", trackScrolling);
      await setWindowHeight(wrappedElement.getBoundingClientRect().bottom)
      await setTimeout(() => {
        handlePageShow();
      }, 500)
    }
  };

  return (
    <div className="flash-sale-page"
      onClick={openSortDrawer ? () => setOpenSortDrawer(false) : null}
    >
      <div className="flash-sale-banner">
        {
          window.screen.availWidth > 480 ?
            <KickImage src={pageDetail && pageDetail.categories && pageDetail.categories[0].pivot && pageDetail.categories[0].pivot.images.find(item => item.orientation === 'landscape').URL} alt="flash sale banner" /> :
            <KickImage src={pageDetail && pageDetail.categories && pageDetail.categories[0].pivot && pageDetail.categories[0].pivot.images.find(item => item.orientation === 'portrait').URL} alt="flash sale banner" />
        }
      </div>
      <Container>
        {
          match.params.slug === "under-retail" || match.params.slug === "merchandise" ?
            <div className="flash-sale-cd">
              <h4><span style={{ fontFamily: "Nunito Regular" }}>End In </span>{pageDetail && <Countdown
                date={pageDetail.expiry.replace(/\s+/g, 'T')}
                renderer={renderer}
                daysInHours={true}
              />}</h4>
            </div> : null
        }
        <div className="flash-sale-widget">
          <div style={{ display: "flex" }}>
            <div className="flash-sale-filter">
              <div onClick={() => handleOpenSortDrawer()} className="fs-sort">
                <h4><span>Sort</span></h4>
                <KickImage style={{ width: "10px", height: "auto", marginLeft: "5px" }} src={ArrowDown} alt="arrow down" />
              </div>
              {
                openSortDrawer && <div style={styleDrawer} className="open-sort-drawer">
                  {
                    sort && sort.map(item => {
                      return <div style={styleOption} key={item.id} className="sort-option" onClick={() => {
                        handleSortChange(item.name)
                        setOpenSortDrawer(!openSortDrawer)
                      }}>
                        <h4 onMouseLeave={() => setHoveredWidget("")} onMouseEnter={() => setHoveredWidget(item.name)} style={selectedSort === item.name || hoveredWidget === item.name ? styleTextBold : styleTextNormal}>{item.name}</h4>
                      </div>
                    })
                  }
                </div>
              }
            </div>
            {
              match.params.slug === "under-retail-bca-launch" && <div style={{ marginLeft: window.screen.availWidth > 480 ? "10px" : "0px" }} className="flash-sale-filter">
                <div onClick={() => handleOpenFilterDrawer()} className="fs-sort fs-filter">
                  <h4><span>Filter</span></h4>
                  <KickImage style={{ width: "10px", height: "auto", marginLeft: "5px" }} src={ArrowDown} alt="arrow down" />
                </div>
                {
                  openFilterDrawer && <div style={{ ...styleDrawer, width: "200px !important" }} className="open-sort-drawer">
                    {
                      filterPrice && filterPrice.map(item => {
                        return <div style={styleOption} key={item.id} className="sort-option" onClick={() => {
                          handleFilterChange(item.name, item.start_price, item.end_price)
                          setOpenFilterDrawer(!openFilterDrawer)
                        }}>
                          <h4 onMouseLeave={() => setHoveredWidget("")} onMouseEnter={() => setHoveredWidget(item.name)} style={selectedFilter === item.name || hoveredWidget === item.name ? styleTextBold : styleTextNormal}>{item.name}</h4>
                        </div>
                      })
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div className="flash-sale-search">
            <div className="fs-search-bar">
              <KickImage src={MagnifyingGlass} alt="magnifying glass" />
              <input value={searchInput} type="text" onChange={handleSearchInput} placeholder="Search" />
            </div>
          </div>
        </div>
        <div className="flash-sale-content">
          {
            data && data.length > 0 && !noData ? data.map(item => {

              const { slug } = match.params
              const categoryUrl = item.product.category.name === "apparels" || item.product.category.name === "Apparels" ? "apparel" : item.product.category.name === "lifestyles" ? "electronics-collectibles" : item.product.category.name === "handbags" ? "luxury" : item.product.category.name;
              const productDetailUrl = slug === "under-retail-bca-launch" ? `/${categoryUrl}/${item.id}/${item.slug}?pre_verified=true?product=under-retail` : `/${categoryUrl}/${item.id}/${item.slug}`;

              return <a
                {
                ... {
                  href: productDetailUrl
                }
                }
                onClick={() => goToProductPage(item.id, item.slug, item.product.category.name)} className={classNames("fs-product", {
                  disabled: item.price <= 0 || item.out_of_stock
                })} key={item.id}>
                <p className={classNames({
                  disabled: item.price <= 0 || item.out_of_stock
                })}>{item.product.brand ? item.product.brand.flat.length > 0 && item.product.brand.flat[0] : ""}</p>
                <p className={classNames({
                  disabled: item.price <= 0 || item.out_of_stock
                })}
                  style={{
                    fontFamily: "Nunito Bold",
                    marginTop: window.screen.availWidth < 400 && "0px",
                    marginBottom: window.screen.availWidth < 400 && "0px",
                    height: window.screen.availWidth < 480 ? "80px" : "30px",
                    width: "90%",
                    fontSize: window.screen.availWidth < 480 ? "12px" : "14px"
                  }}>{item.display_name}</p>
                <KickImage
                  className={classNames({
                    disabled: item.price <= 0 || item.out_of_stock
                  })}
                  src={item.product_variant_images.length > 0 && new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(item.product_variant_images[0].URL)
                    ? getCloudImageUrl(
                      item.product_variant_images[0].URL,
                      400
                    )
                    : emptyImage(dataCategory)} alt={item.display_name} />
                {
                  match.params.slug === "under-retail-bca-launch" &&
                  <p style={{ fontFamily: "Nunito Bold", marginTop: window.screen.availWidth < 480 ? "10px" : "30px", textAlign: "center", width: "95%", fontSize: "10px", color: "#adadad" }}><strike>{
                    item.retail_price > 0 ? <TextRupiah
                      prefix="IDR. "
                      color="#adadad"
                      align="center"
                      value={item.retail_price && item.retail_price.toString() * 14400}
                      bold={true}
                      isFormatRupiah
                    /> : <TextRupiah
                      prefix="IDR. "
                      color="grey"
                      align="center"
                      value={"0"}
                      bold={true}
                      isFormatRupiah
                    />
                  }</strike></p>
                }
                <p
                  className={classNames({
                    disabled: item.price <= 0 || item.out_of_stock
                  })}
                  style={{
                    fontFamily: "Nunito Bold",
                    marginTop: window.screen.availWidth < 480 && match.params.slug === "under-retail-bca-launch" ? "5px" : match.params.slug === "under-retail-bca-launch" && window.screen.availWidth > 480 ? "10px" : "30px",
                    textAlign: "center",
                    width: "95%",
                    fontSize: window.screen.availWidth < 480 ? "12px" : "14px"
                  }}>
                  {
                    item.price > 0 ? <TextRupiah
                      prefix="IDR. "
                      color="black"
                      align="center"
                      value={item.price && item.price.toString()}
                      bold={true}
                      isFormatRupiah
                    /> : "X"
                  }
                </p>
              </a>
            }) : !loading && <div style={{ width: "100vw" }}>
              <KickImage style={{ width: window.screen.availWidth > 480 ? "40%" : "90%", height: "auto", margin: window.screen.availWidth > 480 ? "20px 0px 20px 25%" : "20px 0px 20px 2.5%" }} src={MissingShoes} alt="no data" />
            </div>
          }
        </div>
        {
          loading && (
            <div style={{ marginTop: "80px" }} >
              <SneakerLoadingSpinner
                isLoading={loading || loading && page > 1}
                isHide={!loading}
              />
            </div>
          )
        }
        {
          !dataProduct.isFetching && dataProduct.hasMoreData ?
            <div
              id="load-more-button"
              style={{ width: "100%", backgroundColor: "transparent" }}
            // className="fs-loadMore" onClick={() => handlePageShow()}
            >
            </div> : null
        }
      </Container>
    </div>
  )
}

const mapStateToProps = state => ({
  dataCategory: state.dataCategory.selected,
  dataKaFair: state.dataKaFair,
  underRetailProducts: state.dataKaFair.under_retail,
  merchandiseProducts: state.dataKaFair.merchandise
})

const mapDispatchToProps = dispatch => ({
  getCollectionProductBrands: (category, slug, payload, name) => dispatch(getCollectionProductBrands(category, slug, payload, name)),
  getFlashSaleCollectionList: (category, slug) => dispatch(getFlashSaleCollectionList(category, slug)),
  getFlashSaleSetting: () => dispatch(getFlashSaleSetting()),
  getCollectionList: (category, slug, payload, name) => dispatch(getCollectionList(category, slug, payload, name))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FlashSalePage))
